import { render, staticRenderFns } from "./budget-company.vue?vue&type=template&id=d2d6ff30&scoped=true"
import script from "./budget-company.vue?vue&type=script&lang=js"
export * from "./budget-company.vue?vue&type=script&lang=js"
import style0 from "./budget-company.vue?vue&type=style&index=0&id=d2d6ff30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d6ff30",
  null
  
)

export default component.exports